<template>
  <div class="error401-body-con">
    <Card dis-hover>
      <div class="error401-body-con-title">
           <span class="error401-0-span">
            <Icon type="md-lock"></Icon>
          </span> <span class="error401-key-span">
            <Icon type="md-key"></Icon>
          </span>
      </div>
      <p class="error401-body-con-message">{{ messageText }}</p>
      <div class="error401-btn-con">
        <Button @click="backPage" size="large" style="width: 200px;margin-left: 40px;" type="primary">{{ pathName }}</Button>
      </div>
    </Card>
  </div>
</template>
<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import {commonLocalStorage} from "@/utils/common";

export default {
  name: 'Error401',
  data() {
    return {
      messageText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001128'),
      pathName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001129')
    };
  },
  created() {
    if (this.$route.query.type === '404') {
      this.messageText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001130');
      this.pathName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001131');
    } else {
      this.messageText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001128');
      this.pathName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001132');
    }
  },
  methods: {
    backPage() {
      let system = localStorage.getItem('system');
      // 判断当前系统是 yms 还是 supplier、distributor，然后跳转到指定系统有权限的页面
      if (system === 'yms' || system === 'supplier' || system === 'distributor') {
        this.getPagesPermissions();
      }
    },
    // 获取当前用户下都有哪些页面权限
    getPagesPermissions() {
      const v = this;
      const pagesData = commonLocalStorage.getItem('pagesPermissions') || [];
      // 校验菜单数据
      if (!Array.isArray(pagesData) || pagesData.length === 0) return;
      // 扁平化菜单
      const getAllChildren = (data) => {
        return data.reduce((acc, item) => {
          acc.push(item);
          if (Array.isArray(item.children) && item.children.length > 0) {
            acc.push(...getAllChildren(item.children));
          }
          return acc;
        }, []);
      };

      const pagesMenuList = getAllChildren(pagesData);
      if (pagesMenuList.length === 0) return;
      // 获取角色权限
      const roleData = commonLocalStorage.getItem('roleData') || v.$store.state.roleData || [];

      if (!Array.isArray(roleData) || roleData.length === 0) return;
      // 查找第一个可访问的菜单项
      const firstAllowedPage = pagesMenuList.find((item) => {
        // 条件1：有 path 才能跳转
        if (!item.path) return false;
        // 条件2：jurisdictionHide === true，无需权限判断
        if (item.jurisdictionHide === true) return true;
        // 条件3：menuKey 存在且在 roleData 中
        if (item.menuKey && roleData.includes(item.menuKey)) return true;
        return false;
      });
      // 跳转逻辑
      if (firstAllowedPage && firstAllowedPage.path) {
        v.$router.push(firstAllowedPage.path);
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001133'));
        return false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@keyframes error401animation {
  0% {
    transform: rotateZ(0deg);
  }
  40% {
    transform: rotateZ(-20deg);
  }
  45% {
    transform: rotateZ(-15deg);
  }
  50% {
    transform: rotateZ(-20deg);
  }
  55% {
    transform: rotateZ(-15deg);
  }
  60% {
    transform: rotateZ(-20deg);
  }
  100% {
    transform: rotateZ(0deg);
  }
}

.error401-body-con {
  width: 700px;
  height: 500px;
  margin: 60px auto 0;
}

.error401-body-con-title {
  text-align: center;
  font-size: 240px;
  font-weight: 700;
  color: #2d8cf0;
  height: 260px;
  line-height: 260px;
  margin-top: 40px;
}

.error401-0-span {
  display: inline-block;
  position: relative;
  width: 170px;
  height: 170px;
  border-radius: 50%;
  border: 20px solid #ed3f14;
  color: #ed3f14;
  margin-right: 10px;
}

.error401-body-con-title .error401-0-span i {
  display: inline-block;
  font-size: 120px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.error401-key-span {
  display: inline-block;
  position: relative;
  width: 100px;
  height: 170px;
  border-radius: 50%;
  margin-right: 10px;
}

.error401-body-con-title .error401-key-span i {
  display: inline-block;
  font-size: 190px;
  position: absolute;
  left: 20px;
  transform: translate(-50%, -50%);
  transform-origin: center bottom;
  animation: error401animation 2.8s ease 0s infinite;

}

.error401-body-con-message {
  display: block;
  text-align: center;
  font-size: 25px;
  font-weight: 500;
  letter-spacing: 4px;
  color: #dddde2;
}

.error401-btn-con {
  text-align: center;
  padding: 20px 0;
  margin-bottom: 40px;
}
</style>
